import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=60ae44ac"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=60ae44ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports